import {GET, POST} from '../helpers/request';
import cookies from 'js-cookie';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const SELF_REQUEST = 'SELF_REQUEST';
export const SELF_SUCCESS = 'SELF_SUCCESS';
export const SELF_FAILURE = 'SELF_FAILURE';

const requestLogin = () => ({
  type: LOGIN_REQUEST,
});

const receiveLogin = user => ({
  type: LOGIN_SUCCESS,
  user,
});

const loginError = error => ({
  type: LOGIN_FAILURE,
  error,
});

const requestLogout = () => ({
  type: LOGOUT_REQUEST,
});

const receiveLogout = () => ({
  type: LOGOUT_SUCCESS,
});

const selfRequest = () => ({
  type: SELF_REQUEST,
});

const selfSuccess = user => ({
  type: SELF_SUCCESS,
  user,
});

const selfFailure = error => ({
  type: SELF_FAILURE,
  error,
});

export const demoLogin = projectName => async dispatch => {
  dispatch(requestLogin());

  try {
    const user = await POST({
      endpoint: '/auth/demologin',
      body: {projectName},
    }, dispatch);
    cookies.set('token', user.token, {expires: 365});
    dispatch(receiveLogin(user));
  } catch (error) {
    dispatch(loginError(error.message));
  }
};

export const login = (username, password) => async dispatch => {
  dispatch(requestLogin());

  try {
    const user = await POST({
      endpoint: '/auth',
      body: {username, password},
    }, dispatch);
    cookies.set('token', user.token, {expires: 365});
    dispatch(receiveLogin(user));
  } catch (error) {
    dispatch(loginError(error.message));
  }
};

export const logout = () => async dispatch => {
  dispatch(requestLogout());
  try {
    await POST({
      endpoint: '/auth/logout',
      expectBody: false,
    }, dispatch);
  } catch (error) {
    console.log(error);
  }
  cookies.remove('token');
  dispatch(receiveLogout());
};

export const getSelf = () => async dispatch => {
  dispatch(selfRequest());
  try {
    const user = await GET({endpoint: '/users/me'}, dispatch);
    dispatch(selfSuccess(user));
  } catch (err) {
    dispatch(selfFailure(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/auth.js